import SharedStatus from './shared-status';

export default SharedStatus;
